import { createAction, props } from '@ngrx/store';
import { CountryApiModel } from 'app/models/country-api.model';

export const loadCountries = createAction('[Countries] Load');

export const loadCountriesSuccess = createAction(
  '[Countries] Load Successful',
  props<{ items: CountryApiModel[] }>()
);

export const loadCountriesFailed = createAction(
  '[Countries] Load Failed',
  props<{ error: any }>()
);
